import styled from 'styled-components';

export default styled.div`
  grid-area: label;
  font-size: 0.8rem;
  align-self: end;
  justify-self: start;
  color: black;
`;
